import { Angry as o } from "./angry.js";
import { Annoyed as r } from "./annoyed.js";
import { Bug as m } from "./bug.js";
import { Cat as t } from "./cat.js";
import { Dino as i } from "./dino.js";
import { Doubt as p } from "./doubt.js";
import { Elephant as f } from "./elephant.js";
import { EmoticonHappyXl as e } from "./emoticon-happy-xl.js";
import { EmoticonLove as n } from "./emoticon-love.js";
import { EmoticonShocked as a } from "./emoticon-shocked.js";
import { EmoticonSleep as l } from "./emoticon-sleep.js";
import { EmoticonSuprised as s } from "./emoticon-suprised.js";
import { Emu as c } from "./emu.js";
import { Expressionless as E } from "./expressionless.js";
import { Fish as d } from "./fish.js";
import { Frustrated as A } from "./frustrated.js";
import { Happy as H } from "./happy.js";
import { Heart as h } from "./heart.js";
import { HeartBroken as u } from "./heart-broken.js";
import { HeartHealth as y } from "./heart-health.js";
import { Kangaroo as S } from "./kangaroo.js";
import { Koala as g } from "./koala.js";
import { QAndA as k } from "./q-and-a.js";
import { Relieved as b } from "./relieved.js";
import { Star as v } from "./star.js";
import { Talk as x } from "./talk.js";
import { Unicorn as B } from "./unicorn.js";
import { Whale as D } from "./whale.js";
import { Wombat as F } from "./wombat.js";
const io = {
  Angry: o,
  Annoyed: r,
  Bug: m,
  Cat: t,
  Dino: i,
  Doubt: p,
  Elephant: f,
  EmoticonHappyXl: e,
  EmoticonLove: n,
  EmoticonShocked: a,
  EmoticonSleep: l,
  EmoticonSuprised: s,
  Emu: c,
  Expressionless: E,
  Fish: d,
  Frustrated: A,
  Happy: H,
  Heart: h,
  HeartBroken: u,
  HeartHealth: y,
  Kangaroo: S,
  Koala: g,
  QAndA: k,
  Relieved: b,
  Star: v,
  Talk: x,
  Unicorn: B,
  Whale: D,
  Wombat: F
};
export {
  io as AnimalsAndEmoticons
};
